export var PlayerStates;
(function (PlayerStates) {
    PlayerStates["IS_PASSWORD_BLOCKED"] = "is_password_blocked";
    PlayerStates["VERIFY_FAIL_REACH_LIMIT"] = "not_sms_verify_sendable";
    PlayerStates["IS_FIRST_WITHDRAW_LIMIT"] = "is_first_withdraw_limit";
    PlayerStates["IS_FIRST_WITHDRAW_LIMIT_BY_MANUAL"] = "is_first_withdraw_limit_by_manual";
    PlayerStates["IS_RMB_WITHDRAW_LIMIT"] = "is_rmb_withdraw_limit";
    PlayerStates["IS_SUSPENDED"] = "is_suspended";
    PlayerStates["NOT_TRANSFERABLE"] = "not_transferable";
    PlayerStates["NOT_ACTIVITY"] = "not_activity";
    PlayerStates["NOT_BETABLE"] = "not_betable";
    PlayerStates["NOT_DEPOSITABLE"] = "not_depositable";
    PlayerStates["NOT_WITHDRAWABLE"] = "not_withdrawable";
})(PlayerStates || (PlayerStates = {}));
//# sourceMappingURL=PlayerStates.js.map